import { DialogContent, DialogContentProps } from '@mui/material';

export default DialogContent;
export type { DialogContentProps as ModalContentProps };
